import React from 'react';
import { Box } from "@mui/system";

const SingleProject = ({project}) => {
    const {img} = project;
    return (
        <Box>
            <img src={img} style={{ width: '200px', height: '200px' }} alt="" />
        </Box>
    );
};

export default SingleProject;